import request from '@/api'

// 查询场景集列表
export async function getSceneSetList(data) {
  return request({
    url: '/capi/app-service/app/getSimulationSceneSetList',
    method: 'post',
    data
  })
}

// 查询场景列表
export async function getSceneList(data) {
  return request({
    url: '/capi/app-service/app/getSimulationSceneList',
    method: 'post',
    data
  })
}

// 查询应用状态
export async function getAppTestInfo(data) {
  return request({
    url: '/capi/app-service/app/getAppTestInfo',
    method: 'post',
    data
  })
}

// 重新开发接口
export async function backAppTest(data) {
  return request({
    url: '/capi/app-service/app/backAppTest',
    method: 'post',
    data
  })
}

// 提交测试接口
export async function setAppTestInfo(data) {
  return request({
    url: '/capi/app-service/app/setAppTestInfo',
    method: 'post',
    data
  })
}

// 取消排队接口
export async function cancelAppTest(data) {
  return request({
    url: '/capi/app-service/app/cancelAppTest',
    method: 'post',
    data
  })
}

export async function getDetails(data) {
  return request({
    url: '/capi/app-service/app/selectOneApp',
    method: 'post',
    data
  })
}

export async function selectCountApp(data) {
  return request({
    url: '/capi/app-service/app/selectCountApp',
    method: 'post',
    data
  })
}

export async function getSceneSetTree(data) {
  return request({
    url: '/capi/app-service/app/getSceneSetTree',
    method: 'post',
    data
  })
}

export async function getModuleList(data) {
  return request({
    url: '/capi/app-service/app/moduleList',
    method: 'post',
    data
  })
}

export async function getIndicatorGroupList(data) {
  return request({
    url: '/capi/app-service/app/indicatorGroupList',
    method: 'post',
    data
  })
}

export async function getIndicatorGroupDetail(id) {
  return request({
    url: `/capi/app-service/app/indicatorGroupDetail/${id}`,
    method: 'post'
  })
}
// 入门级开发工具-发送验证码
export async function sendCodeByEmail(data) {
  return request({
    url: `/capi/web-service/uaes/commons/sendMail`,
    method: 'post',
    data
  })
}
// 入门级开发工具-验证码校验
export async function verifyCodeByEmail(data) {
  return request({
    url: `/capi/web-service/uaes/commons/verifyCode`,
    method: 'post',
    data
  })
}
// 发布
export async function releaseApp(data) {
  return request({
    url: `/capi/app-service/app/releaseApp`,
    method: 'post',
    data
  })
}
// 重新开发
export async function backDevelopTadsim(data) {
  return request({
    url: `/capi/app-service/app/backDevelopTadsim`,
    method: 'post',
    data
  })
}
// 重新发布
export async function releaseAppAgain(data) {
  return request({
    url: `/capi/app-service/app/releaseAppAgain`,
    method: 'post',
    data
  })
}
